module.exports = __webpack_public_path__ + "static/media/logo_white.77ef0794.svg";